import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DefaultMetaDataServiceImpl } from '../../interfaces/DefaultMetaDataServiceImpl';
import { BaseMetaDataService } from './base-meta-data.service';

@Injectable({ providedIn: 'root' })
export class DefaultMetaDataService extends BaseMetaDataService {
  constructor(http: HttpClient) {
    super(http, undefined, new DefaultMetaDataServiceImpl());
  }
}
